import { render, staticRenderFns } from "./viewApplication.vue?vue&type=template&id=06fe16f3&scoped=true"
import script from "./viewApplication.vue?vue&type=script&lang=js"
export * from "./viewApplication.vue?vue&type=script&lang=js"
import style0 from "./viewApplication.vue?vue&type=style&index=0&id=06fe16f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fe16f3",
  null
  
)

export default component.exports